import { createReducer } from '@reduxjs/toolkit';

import getJobsFailed from '../../thunks/jobs/getJobsFailed';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
};

const getJobsFailedReducer = createReducer(initialState, {
  [getJobsFailed.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getJobsFailed.fulfilled]: (state, { payload: { data, total, ...props } }) => ({
    ...state,
    loading: false,
    data,
    total,
    ...props
  }),
  [getJobsFailed.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getJobsFailedReducer;
